"use client";
import { useState, useEffect } from "react";
import { LoadingContext } from "./LoadingContext";
import { registerLoadingCallback } from "@/lib/axiosClient";

export function LoadingProvider({ children }: { children: React.ReactNode }) {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        registerLoadingCallback((loading: boolean) => {
            setIsLoading(loading);
        });
    }, []);

    return (
        <LoadingContext.Provider value={{ isLoading }}>
            {children}
        </LoadingContext.Provider>
    );
}
